import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {Link, withRouter } from "react-router-dom";

import * as AppActions from "../../reducers/appReducer";
import * as AppUserActions from "../../reducers/appUsersDevicesReducer";
import * as UserActions from "../../reducers/userReducer";

import logo from "../../img/wagz-icon.png";
import {appChanged} from "../../utils/changeHelpers";
import { error } from "../structure/Alert";

interface INavProps {
  appActions: any;
  appUserActions: any;
  userActions: any;
  appState: any;
  userState: any;
  history: any;
}

interface INavState {
  open: boolean;
}


class NavBar extends React.Component<INavProps, INavState> {

  constructor(props: any){
    super(props);

    this.logout = this.logout.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
    this.changeApp = this.changeApp.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  public logout(){
    this.props.userActions.logoutUser();
    window.localStorage.clear();
    this.props.history.push("/login");
  }

  public toggleMenu(e: any){
    e.preventDefault();
    this.props.appActions.toggleMenu();
  }

  public toggleHelp(e: any){
    e.preventDefault();
    this.props.appActions.toggleHelp();
  }

  public refresh(e: any){
    e.preventDefault();
    this.changeApp({target: {value: this.props.appState.app}});
  }

  public async changeApp(e: any){
    const app = e.target.value;
    this.props.appActions.changeApp({
      app
    });
    try{
      const {users, devices, plans} = await appChanged(app);
      this.props.appUserActions.updateAppUsers({app, users});
      this.props.appUserActions.updateAppDevices({app, devices});
      this.props.appUserActions.updateAppPlans({app, plans});
      this.props.history.push("/support/users");
    } catch(err){
      error("Could not change app, please contact engineering");
    }
  }

  get links(){
    const helpText = this.props.appState.showHelp ? "Toggle Help Off" : "Toggle Help On";
    if(this.props.userState.loggedIn) {
      return (
        <div>
          <ul className="nav navbar-nav">
            <li><a href="#" onClick={this.toggleMenu}>Menu</a></li>
          </ul>
          <ul className="nav navbar-nav navbar-right">
            <li><a href="#" onClick={this.toggleHelp}>{helpText}</a></li>
            <li><a href="#" onClick={this.logout}>Logout</a></li>
          </ul>
          <div className="col-sm-8 col-md-8 col-md-offset-1">
            <form className="navbar-form form-inline" role="search">
              <div className="input-group">
                <select
                  id="appSelectedApp"
                  className="form-control"
                  value={this.props.appState.app}
                  onChange={this.changeApp}>
                  <option value="wagz2">Wagz</option>
                  <option value="bd">Black and Decker v1</option>
                  <option value="petzi" disabled={true}>Petzi (Not Available Until Merged)</option>
                </select>
              </div>
                <button className="btn btn-small btn-success" onClick={this.refresh}>Refresh</button>
            </form>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <ul className="nav navbar-nav">
            <li><Link to="/login" id="nav-login">Login</Link></li>
          </ul>
          <ul className="nav navbar-nav navbar-right">
            <li><a href="#" onClick={this.toggleHelp}>{helpText}</a></li>
          </ul>
        </div>
      );
    }
  }

  get header(){
    if(this.props.userState.loggedIn) {
      return (
        <a className="navbar-brand" href="#" onClick={this.toggleMenu}><img src={logo} alt="logo" height="24px" width="24px" /></a>
      );
    } else {
      return (
        <a className="navbar-brand" href="/"><img src={logo} alt="logo" height="24px" width="24px" /></a>
      );
    }
  }
  
  public render (){
    let classes = "navbar navbar-default";
    if(this.props.appState.app !== ""){
      classes += ` ${this.props.appState.app}-bar`;
    }
    return (
      <div id="navbar">
        <nav className={classes} style={{borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px"}}>
          <div className="navbar-header">
              {this.header}
          </div>
          <div className="collapse navbar-collapse">
            {this.links}
          </div>
        </nav>
      </div>);
  }
}


const mapStateToProps = function map(s: any) {
  return {
    appState: s.appState,
    userState: s.userState,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    appActions: bindActionCreators(AppActions, dispatch),
    appUserActions: bindActionCreators(AppUserActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar)  as React.ComponentType<any>);